module.exports = __webpack_public_path__ + "static/img/ota-logo.31c65d68.png";